<template>
  <div class="deviceClause section">
    <div class="section-header">
      <div></div>
      <div class="exportClass">
      <!-- <download-excel
        v-show="currentData"
        class = "export-excel"
        :data = "json_data"
        :name = "filename">
        <button class="button-export">{{$t('report.Export_report')}}</button>
      </download-excel> -->
      <button v-show="currentData" @click="exportDeviceDetail()" class="button-export">{{$t('report.Export_report')}}</button>
      <el-date-picker
        v-model="selectedDate"
        :editable="false"
        :clearable="false"
      >
      </el-date-picker>
      </div>
    </div>
    <div class="section-content">
      <el-table
        height="100%"
        :data="tableData"
        stripe
        border
        :row-style="{height:0}"
        :cell-style="{padding:0}"
        :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
        v-loading="isLoading"
        element-loading-spinner="el-icon-loading"
      >
      <!-- :empty-text="$t('message.nodata')" -->
        <el-table-column
          :label="item"
          v-for="(item,index) in tableDataFields"
          show-overflow-tooltip
          width="180px"
          :prop="item"
          :key="index"
          :fixed="index == 0"
        >
          <template slot="header" slot-scope="scope">
            <span :title="scope.column.label">{{scope.column.label}}</span>
          </template>
        </el-table-column>
        <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
        <div style="line-height: 32px">{{$t('account.nodata')}}</div></div>
      </el-table>
    </div>
     <el-pagination
      class="pagination"
      v-if="paginationControl"
      background
      @size-change="queryData(true)"
      @current-change="()=>queryData()"
      :current-page.sync="pagination.currentPage"
      :page-sizes="[10,15,20,30]"
      :page-size.sync="pagination.pagesize"
      layout="total, prev, pager, next, sizes, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 占个坑位，不然分页会掉出来屏幕之下 -->
    <div v-else class="pagination"></div>
  </div>
</template>
<script>
import { mapGetters,mapState} from 'vuex'
import encryption from "@/assets/js/encryption";
import request from "@/assets/js/request";
import config from "@/assets/js/config";
import cookie from '@/assets/js/cookie';
export default {
  data() {
    return {
      emptyText: false,
      currentData:true,
      paginationControl:false,
      // filename:'',//导出文件名称
      // json_data:[],
      selectedDate: new Date(), // 所选时间
      isLoading: false, // 正在加载数据
      tableDataFields: [], // 表格列标题
      tableData: [], // 表格数据
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      } // 分页数据
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })

  },
  watch: {
    deviceInfo: {
      handler() {
        this.queryData()
      },
      deep: true
    },
    selectedDate () {
      this.queryData()
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    // 查询表格数据
    queryData (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
        let ps = this.isMicroService ? 'pageSize': 'pagesize'
       let param = {
          page: this.isMicroService ? this.pagination.currentPage : this.pagination.currentPage - 1,
          [ps]: this.pagination.pagesize,
          i18n: this.$lang.currentLang,
          pn: this.deviceInfo.pn,
          devcode: this.deviceInfo.devcode,
          devaddr: this.deviceInfo.devaddr,
          sn: this.deviceInfo.sn,
          date: this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
        };
        // let REdata = new Date()
        // if(param.date >REdata){
        //   console.log("retue")
        //   return
        // }
        let url = this.isMicroService ? "/drt/api/auth/web/deviceDats" : "queryDeviceDataOneDayPaging";
      this.$request[this.method](url, param)
        .then(res => {
          if (res[this.code] === 0) {
            this.currentData = true;
            this.pagination.total = res[this.resData].total
            let tableData = [],
              //  tableDataNoId=[],
              tableDataFields = [],
              title = res[this.resData].title,
              row = res[this.resData].row
            row.forEach((item, rowIndex) => {
              let clause = {} ;
              // clauseNoId = {}
              item.field.forEach((val, index) => {
                //每个英文单词首字母大写
                // let field = this.$filter.capitalFirstLetter(title[index].title)
                let field = title[index].title
                if (title[index].unit) {
                  field += `(${title[index].unit})`
                }
                !rowIndex && field !== "id" && tableDataFields.push(field)
                clause[field] = val;
              });
              tableData.push(clause)
              // item.field.forEach((val, index) => {
              //   let field = this.$filter.capitalFirstLetter(title[index].title)
              //   if (title[index].unit) {
              //     field += `(${title[index].unit})`
              //   }
              //   if(field == "Id") return
              //   clauseNoId[field] = val;
              // });
              // tableDataNoId.push(clauseNoId)
            })
            this.tableData = tableData
            this.tableDataFields = tableDataFields
            // this.filename =  this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
            // this.json_data = tableDataNoId
            if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
          } else {
            this.emptyText = true;
            this.pagination.total = 0
            this.tableData = []
            this.tableDataFields = []
            this.currentData = false
            // this.filename =  this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
            // if(this.$lang.currentLang == 'zh_CN'){
            //   this.json_data = [{"无数据,请重新选择时间":""}]
            // }else{
            //   this.json_data = [{"No data, please choose a new time":""}]
            // }
          }
          this.isLoading= false
        })
    },
    
    exportDeviceDetail() {
      let param = {
        action:"exportDeviceDataDetail",
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        i18n: this.$lang.currentLang,
        pn: this.deviceInfo.pn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        date: this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
      };
      // ===== 【微服务版本】exportDeviceDataDetail start（微服务接口未上线，暂注释；上线后：取消注释本段，并注释掉下方【原dis版本】） =====
      // let url = this.isMicroService ? "/drt/api/auth/web/exportDeviceDataDetail" : "exportDeviceDataDetail";
      // this.$request[this.isMicroService ? "postDEVMicroservices" : "get"](url,param)
      //     .then((res) => {
      //       // 演示账号
      //       if(res[this.code]){
      //         this.$message.error(this.$t(`errCode.${res[this.code]}`));
      //         return;
      //       }else{
      //         // ......................
      //         window.location.href = this.$request.http_download_url_new(param)
      //         // this.closeDialog();
      //         // ......................
      //       }
      //       this.$message.success(this.$t("report.download"));
      //     })
      //     .then(() => {
      //       // this.$message.success(this.$t("report.download"));
      //     }).catch((err) => {
      //       this.$message.error(err);
      //     });
      // ===== 【微服务版本】exportDeviceDataDetail end =====
      // ===== 【原dis版本】exportDeviceDataDetail start（当前启用；微服务上线后请注释掉本段） =====
      this.$request.get("exportDeviceDataDetail", param)
          .then((res) => {
            // 演示账号
            if(res.err){
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            }else{
              // ......................
              window.location.href = this.$request.http_download_url_new(param)
              // this.closeDialog();
              // ......................
            }
            this.$message.success(this.$t("report.download"));
          })
          .then(() => {
            // this.$message.success(this.$t("report.download"));
          }).catch((err) => {
            this.$message.error(err);
          });
      // ===== 【原dis版本】exportDeviceDataDetail end =====
    }
  },
}
</script>
<style lang="less" scoped>
.deviceClause {
  display: flex;
  flex-direction: column;
  .section-header {
    padding: 20px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .exportClass{
      display:flex;
      flex-direction:row;
    }
    .button-export{
      font-size: 14px;
      padding:7px 16px;
      border-radius: 4px;
      background: var(--theme-color);
      margin-right: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
  .section-content {
    flex: 1;
    overflow: auto;
  /deep/.el-icon-loading{
    font-size: 28px;
    }
  }
  .pagination {
      line-height: 32px;
      height: 32px;
      // margin-top: 20px;
      // align-self: flex-end;
    }
}
    .section{
      border:none;
      box-shadow:none;
      padding:0;
  }
</style>